module.exports = __webpack_public_path__ + "img/series_08.edc247a9.png";